// extracted by mini-css-extract-plugin
export default {"root":"Sidebar_root__v0GHY","logo":"Sidebar_logo__Mc4Gd","nav":"Sidebar_nav__TRQLQ"};